import {ChemDrawStoichiometryData, ParseReactionComponentsResponse} from 'chemistry/ChemistryConstants';
import {ExternalFile} from 'notebook/util/NoteUtilConstants';
import * as net from 'util/Net';

export const SALT_LIBRARY_URL = '/salts/listing';
export const SOLVATE_LIBRARY_URL = '/solvates/listing';

export function bulkFetchChemDrawStoichiometryData(
  noteLinkedObjectIds: Array<string>
): Promise<{[noteLinkedObjectId: string]: ChemDrawStoichiometryData}> {
  return net.postJSONPromise({
    url: '/1/api/chemistry:bulk-fetch-chemdraw-stoichiometry-data',
    data: {noteLinkedObjectIds},
  });
}

export function parseReactionComponents(
  mrvFile: string,
  folderId: string | undefined
): Promise<ParseReactionComponentsResponse> {
  return net.postJSONPromise({
    url: '/1/api/reactions:process-components',
    data: {mrvFile, folderId},
  });
}

export function generateReactionImage(mrvFile: string): Promise<{base64SVG: string}> {
  return net.postJSONPromise({
    url: '/1/api/reactions:generate-image',
    data: {mrvFile},
  });
}

export interface BuildReactionFromComponentsResponse {
  externalFile: ExternalFile;
}

export function buildReactionFromComponents(
  reactantMoleculeIds: Array<string>,
  productMoleculeIds: Array<string>
): Promise<BuildReactionFromComponentsResponse> {
  return net.postJSONPromise({
    url: '/1/api/reactions:build-from-components',
    data: {reactantMoleculeIds, productMoleculeIds},
  });
}

export function createSalt(name: string, smiles: string, code?: string): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/salts',
    data: {name, smiles, ...(code ? {code} : {})},
  });
}

export function createSolvate(name: string, smiles: string, code?: string): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/solvates',
    data: {name, smiles, ...(code ? {code} : {})},
  });
}

export function archiveSalts(saltIds: Array<string>, purpose: string): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/salts:archive',
    data: {saltIds, purpose},
  });
}

export function unarchiveSalts(saltIds: Array<string>): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/salts:unarchive',
    data: {saltIds},
  });
}

export function archiveSolvates(solvateIds: Array<string>, purpose: string): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/solvates:archive',
    data: {solvateIds, purpose},
  });
}

export function unarchiveSolvates(solvateIds: Array<string>): Promise<void> {
  return net.postJSONPromise({
    url: '/1/api/solvates:unarchive',
    data: {solvateIds},
  });
}
